/* global fetch */

export default function fetcher(args) {
  const { path, onData } = args
  fetch(path)
    .then(r => r.json())
    .then(v => {
      onData(v)
    })
    .catch(() => {
      setTimeout(() => fetcher(args), 1000)
    })
}



// WEBPACK FOOTER //
// ./utils/fetcher.js